import { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    MobileIcon,
    ModalHeader,
} from "../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import { useSelector } from "react-redux";
import {
    Select,
    MenuItem,
} from "@mui/material";

const vendorSchema = Yup.object().shape({
    fullName: Yup.string()
        .matches(/^[A-Za-z ]+$/, "Name should contain only alphabets")
        .min(4, "Name must be at least 4 characters long")
        .required("Vendor name is required"),
    mobile: Yup.string()
        .matches(/^\d{10}$/, "Mobile number must be 10 digits")
        .nullable(),
    type: Yup.number().optional()
});

const EditVendor = ({ editVendorMutate, editVendorLoading, handleClose, selectedData }) => {

    const initialValues = {
        fullName: selectedData.name || "",
        mobile: selectedData.mobile || "",
        type: selectedData.type ? selectedData.type.toString() : "",
    };

    const [height, setHeight] = useState(window.innerHeight);
    const vendorTypes1 = useSelector((state) => state.VendorTypesReducer.vendorTypes);
    const vendorTypeOptions = vendorTypes1
        ?.filter(type => type?.name && type?.id) // ✅ skip null or empty
        .map(type => ({
            label: type.name,
            value: type.id.toString(),
        }));

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleSubmit = (values) => {
        editVendorMutate({
            name: values.fullName,
            mobile: values.mobile,
            vendorId: selectedData.id,
            type: parseInt(values.type)
        });
    };

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Edit Vendor</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={vendorSchema}
                >
                    {({ values, setFieldValue, errors, touched, handleChange, handleBlur }) => (
                        <Form>
                            <ScrollableContent>
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="fullName">Vendor Name *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="text"
                                                name="fullName"
                                                id="fullName"
                                                autoComplete="off"
                                            />
                                        </FieldWrappers>
                                        {errors.fullName && touched.fullName && (
                                            <ErrorMessage>{errors.fullName}</ErrorMessage>
                                        )}
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="mobile">Mobile Number</Label>
                                        <FieldWrappers>
                                            <MobileIcon />
                                            <Field
                                                type="text"
                                                name="mobile"
                                                id="mobile"
                                                autoComplete="off"
                                                maxLength={10}
                                                className="pl-5"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d{0,10}$/.test(value)) {
                                                        setFieldValue("mobile", value);
                                                    }
                                                }}
                                            />
                                        </FieldWrappers>
                                        {errors.mobile && touched.mobile && (
                                            <ErrorMessage>{errors.mobile}</ErrorMessage>
                                        )}
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="type">Type </Label>
                                        <Select
                                            className="w-full pl-2"
                                            id="type"
                                            name="type"
                                            value={values.type}
                                            onChange={(event) => {
                                                setFieldValue("type", event.target.value);
                                            }}
                                            style={{ height: "46px" }}
                                        >
                                            {vendorTypeOptions?.map((option) => (
                                                <MenuItem
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>

                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={editVendorLoading}>
                                    {editVendorLoading ? "Updating..." : "Update"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
export default EditVendor;